import { AxiosInstance } from "axios";
import { LoginConfigResponse } from "../types/loginConfig";
import { getApiClient } from "../utils/api.utils";

export class LoginConfigService {
  client: AxiosInstance;
  constructor() {
    this.client = getApiClient();
  }
  getLoginConfig = async (tenantLoginId: string) => {
    const response = await this.client.get<LoginConfigResponse>(
      `/auth/login-config/${tenantLoginId}`
    );
    return response.data;
  };
}
